import {fetch} from "utils/dataAccess";

export default function list(params) {
    return new Promise((resolve, reject) => {
        fetch(`/retailers?${params}`).then(response => {
            response.json().then(response => {
                resolve(response["hydra:member"])
            })
        }).catch(error => reject(error));
    });
}

export function listProfiles(params) {
    return new Promise((resolve, reject) => {
        fetch(`/retailer_profiles?${params}`).then(response => {
            response.json().then(response => {
                resolve(response["hydra:member"])
            })
        }).catch(error => reject(error));
    });
}
